import { format } from "date-fns";
import { de } from "date-fns/locale";

import type { CalendarActions, CalendarDay } from "~/modules/dashboard/components/TimeTrackingCalendar/calendarDays.ts";
import { HolidayAndAbsenceBars } from "~/modules/dashboard/components/TimeTrackingCalendar/HolidayAndAbsenceBars.tsx";
import { TrackingCard } from "~/modules/dashboard/components/TimeTrackingCalendar/TrackingCard.tsx";
import { TrackingRow } from "~/modules/dashboard/components/TimeTrackingCalendar/TrackingRow.tsx";
import { AddTimeTrackingButton } from "~/modules/timeTracking/components/components/AddTimeTrackingButton.tsx";

type Props = CalendarActions & {
	day: CalendarDay;
	// The phone body shows the "+" as a primary button.
	primaryAdd?: boolean;
};

/** The selected day below the compact grid: its holiday, its absences, its trackings and its "+". */
export function DayList(props: Props) {
	const {
		absenceActions,
		day,
		primaryAdd,
		canAddTrackingOn,
		canAddAbsence,
		showDisabledAddTracking,
		openCreate,
		openUpdate,
		openDelete,
		selectedTimeTrackingId,
		setSelectedTimeTrackingId,
	} = props;
	const canAddEntry = canAddAbsence || canAddTrackingOn(day.date);
	const close = () => setSelectedTimeTrackingId(null);

	return (
		<div className="flex min-w-0 flex-col gap-2">
			{/* From `md`, the selected `DayColumn` shows the date. Below `md`, the compact grid title shows only the month, so the date stays here. */}
			<h4 className="text-sm font-semibold text-gray-700 md:hidden">{format(day.date, "EEEE, d. MMMM", { locale: de })}</h4>
			<HolidayAndAbsenceBars day={day}
							   absenceActions={absenceActions}
							   inPlace />
			{day.timeTrackings.map((timeTracking) => timeTracking.id === selectedTimeTrackingId ? (
				<TrackingCard key={timeTracking.id}
							  timeTracking={timeTracking}
							  onClickEdit={() => {
								  close();
								  openUpdate(timeTracking.id);
							  }}
							  onClickDelete={() => {
								  close();
								  openDelete(timeTracking.id);
							  }}
							  onClickClose={close} />
			) : (
				<TrackingRow key={timeTracking.id}
							 timeTracking={timeTracking}
							 onClick={() => setSelectedTimeTrackingId(timeTracking.id)} />
			))}
			{(canAddEntry || showDisabledAddTracking) && (
				<AddTimeTrackingButton date={day.date}
									   canAddTracking={canAddEntry}
									   openCreate={openCreate}
									   primary={primaryAdd} />
			)}
		</div>
	);
}
